module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setBooks_box"
  }, [_c('div', {
    staticClass: "setBooks",
    staticStyle: {
      "padding": "40px"
    }
  }, [_c('div', {
    staticClass: "header clear"
  }, [_c('form', {
    staticClass: "search",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.search($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "field",
    attrs: {
      "type": "text",
      "placeholder": "搜索试卷名称"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'clearBtn': _vm.keyword.trim().length > 0
    },
    on: {
      "click": function($event) {
        _vm.clearInput($event)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button green",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.search($event)
      }
    }
  }, [_vm._v("搜索")])])]), _vm._v(" "), _c('article', {
    staticClass: "book_list clear"
  }, [_c('ul', {
    staticClass: "clear"
  }, _vm._l((_vm.papers), function(item) {
    return _c('li', [_c('book', {
      attrs: {
        "booksData": item,
        "type": 2
      }
    })], 1)
  }))]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading_books"
  }, [_c('div', {
    staticClass: "load_line"
  }), _vm._v(" "), _c('p', [_vm._v("正在加载中...")])]) : _vm._e(), _vm._v(" "), (_vm.papers.length == 0 && !_vm.isSearch) ? _c('div', {
    staticClass: "noCatalog clear"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/img/null.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂时还没有试卷哦")])]) : _vm._e(), _vm._v(" "), (_vm.papers.length == 0 && _vm.pageIndex == 1 && _vm.isSearch) ? _c('div', {
    staticClass: "noResult clear"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/img/null.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("搜索无结果")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c20a5a9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/setWork/setPaper.vue
// module id = 1200
// module chunks = 1